// components/PrivateRoute.tsx
import { Navigate } from "react-router-dom";
import { ReactNode, useContext } from "react";
import { AuthContext } from "../context/authContext";

interface PrivateRouteProps {
  children: ReactNode;
  allowedRoles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  allowedRoles = [],
}) => {
  const { currentUser, hasLoggedOut } = useContext(AuthContext);
  console.log(currentUser);

  if (!currentUser) {
    return <Navigate to={hasLoggedOut ? "/login" : "/landing"} replace />;
  }

  // If role-based access control is specified, check if the user's role is allowed
  if (
    allowedRoles.length > 0 &&
    !allowedRoles.includes(currentUser?.role.displayName)
  ) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
